import {Box, Skeleton, Image} from '@chakra-ui/react';
import {ModalTypes, useModalContext} from '..';
import {getGeneratedImageUrl, ImageUrl} from '../../../utils/utils';

export const translate: Record<ModalTypes, ImageUrl> = {
  certificate: 'certificate',
  redeem: 'gift-card-img',
  share: 'sharing-img',
  wallet: 'wallet',
  deed: 'deed',
};

export const Content = (): JSX.Element => {
  const {
    type,
    setIsLoaded,
    isLoaded,
    transactionId,
    userId,
    assetId,
    signature,
  } = useModalContext();

  const contentOption: Record<ModalTypes, any> = {
    certificate: {
      userId,
      assetId,
      signature,
    },
    share: {
      userId,
      assetId,
      signature,
    },
    redeem: {
      transactionId,
    },
    wallet: {
      userId,
      assetId,
    },
    deed: {},
  };

  return (
    <>
      <Box
        pos="relative"
        width="100%"
        height={{base: '47vw', sm: '49vw'}}
        maxH={{base: '315px', xl: '381px'}}
      >
        <Box
          onLoad={() => setIsLoaded(true)}
          opacity={isLoaded ? 1 : 0.5}
          transition="linear 0.7s all"
          pos="absolute"
          zIndex="docked"
        >
          <Image
            id={type}
            src={getGeneratedImageUrl(translate[type], contentOption[type])}
            alt={`${type} image`}
          />
        </Box>
        <Skeleton
          width="100%"
          height="100%"
          pos="absolute"
          borderRadius={type !== 'certificate' ? '20px' : ''}
        />
      </Box>
    </>
  );
};
